import { useContext, useEffect, useState } from "react"
import Context from "containers/UMS/Users/Context"
import { useQuery } from "react-query";
import { getUsers } from "utils/requests";
import { ColumnsType } from "components/Table/interface";
// components
import BaseLayout from "components/BaseLayout"
import TableComponent from "components/Table";
// andt
import { Alert, Button, Input } from "antd";
// icons
import { MdOutlineArrowBackIosNew } from "react-icons/md"
import { SearchOutlined } from '@ant-design/icons'
// helpers
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import useMergeUSer from "./useMergeUser";
import UserCard from "./UserCard";
import { useTranslation } from "react-i18next";

const MERGE_USER_LIMIT = 5

const columns: ColumnsType<any> = [
  {
    title: 'Usuario',
    dataIndex: 'identity_first_name',
    type: 'userCell'
  },
  {
    title: 'Email',
    dataIndex: 'identity_email'
  },
  {
    title: 'Teléfono',
    dataIndex: 'identity_phone'
  },
  {
    title: 'Puntos disponibles',
    dataIndex: 'identity_point_count'
  }
]


const UserMerge: React.FC = () => {
  const { t } = useTranslation()
  const { queryHandler: { data: dataQuery }, states: { selectedUser } } = useContext(Context)
  const [toMergeUser, setToMergeUser] = useState({})
  const [filter, setFilter] = useState('')
  const [searchInput, setSearchInput] = useState('')
  const [page, setPage] = useState(1)
  const { onMerge, isLoading, handleClose } = useMergeUSer({ userToMerge: toMergeUser })
  const { data: usersData, isFetching, refetch } = useQuery({
    queryKey: 'userToMerge',
    initialData: { data: [], paginationInfo: {} },
    queryFn: () =>
      getUsers({
        is_fraudulent: false,
        page,
        search: filter,
        limit: MERGE_USER_LIMIT
      })
  })
  const data = get(dataQuery, 'data', [])

  const user = data.find(({ identity_uuid }) => identity_uuid === selectedUser)

  useEffect(() => {
    refetch()
  }, [page, searchInput])

  useEffect(() => {
    const time = setTimeout(() => {
      if (filter != searchInput) {
        setSearchInput(filter)
        setPage(1)
      }
    }, 600)
    return () => clearTimeout(time)
  }, [filter])

  return (
    <div className="mergeUserContainer">
      <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "center" }}>
        <BaseLayout
          className="MergeUser"
          title=""
        >
          <Alert message={t("MERGE_USER_MESSAGE")} description={t("MERGE_USER_DESCRIPTION")} type="info" />
          <div className="usersMergeData">
            <UserCard user={toMergeUser as any} title="Cuenta destino" />
            <MdOutlineArrowBackIosNew color="#0061df" fontSize={30} />
            <UserCard user={user} title="Cuenta origen" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

            <Button onClick={handleClose} disabled={isLoading}>Cancelar</Button>
            <Button onClick={onMerge} loading={isLoading} type="primary" disabled={isEmpty(toMergeUser)}>Transferir cuenta</Button>
          </div>

        </BaseLayout>
        <BaseLayout
          className="userTable"
          title=""
        >
          <Input
            size="large"
            placeholder="Busca por nombre, email o número celular"
            prefix={<SearchOutlined />}
            value={filter}
            style={{ marginTop: '1rem' }}
            onChange={e => setFilter(() => e.target.value)}
          />
          <TableComponent
            key={'usersToMerge'}
            emptyData={usersData.data.length === 0 && !isFetching}
            columns={columns}
            data={usersData.data}
            rows={MERGE_USER_LIMIT}
            loading={isFetching}
            page={page}
            total={usersData.paginationInfo.totalRecords}
            setPage={setPage}
            rowClassName={(record) => {
              if (get(record, 'identity_uuid', '') === selectedUser) return 'sameUser'
              return record.identity_uuid === get(toMergeUser, 'identity_uuid', '') ? 'selectedRow userRow' : 'userRow'
            }
            }
            onRow={(record, rowIndex) => {
              return {
                onClick: (e) => {
                  if (get(record, 'identity_uuid', '') === selectedUser) return
                  if (get(record, 'identity_uuid', '') === get(toMergeUser, 'identity_uuid', '')) return setToMergeUser({})
                  setToMergeUser(record)
                }
              }
            }}
          />
        </BaseLayout>
      </div>
    </div>
  )
}

export default UserMerge